import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Teleton_Title } from '../../../../../utils/ES/Modals/PostModals';

const ModalPostTeleton = () => {
  return (
    <>
      <ModalVideo
        id="teleton-post"
        dataText={Teleton_Title}
        videoSrc="https://player.vimeo.com/video/600399977?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_TELETON"
      />
    </>
  );
};

export default ModalPostTeleton;
